// Cluster Articles: Pflegebegleitung Serie (7 Artikel)
const clusterPflegebegleitung = [
  {
    slug: "pflegebegleitung-angehoerige",
    title: "Pflegebegleitung für Angehörige: Welche Unterstützung ist möglich?",
    metaTitle: "Pflegebegleitung für Angehörige: Mögliche Unterstützung",
    metaDescription: "Wie können pflegende Angehörige durch Pflegebegleitung unterstützt werden? Belastungen, Entlastungsmöglichkeiten und praktische Beispiele.",
    category: "Angehörige",
    readTime: "8 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Pflegende Angehörige tragen eine enorme Verantwortung. Tag für Tag kümmern sie sich um ihre Liebsten \u2014 oft unter großem persönlichem Einsatz. Pflegebegleitung kann dazu beitragen, diese Belastung zu lindern und den Pflegealltag besser zu bewältigen. Dieser Artikel zeigt, welche Unterstützung möglich ist.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-pflegeberatung", "pflegebegleitung-demenz", "pflegebegleitung-pflegegrad", "sozialraumbudget-angehoerige", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Die Belastung pflegender Angehöriger",
        paragraphs: [
          "Rund 80 Prozent der Pflegebedürftigen in Deutschland werden zuhause versorgt. In den meisten Fällen übernehmen Familienangehörige die Hauptverantwortung \u2014 Ehepartner, Kinder, Schwiegerkinder. Diese Pflege geschieht oft neben Beruf, eigener Familie und eigenen gesundheitlichen Einschränkungen.",
          "Studien zeigen, dass pflegende Angehörige ein deutlich erhöhtes Risiko für Depressionen, Burnout und körperliche Erkrankungen haben. Viele fühlen sich alleingelassen und wissen nicht, an wen sie sich wenden können."
        ]
      },
      {
        heading: "Emotionale Herausforderungen",
        paragraphs: [
          "Neben den praktischen Aufgaben stellt die Pflege auch eine enorme emotionale Belastung dar. Pflegende Angehörige erleben häufig:"
        ],
        bullets: [
          "Schuldgefühle \u2014 das Gefühl, nicht genug zu tun oder den Anforderungen nicht gerecht zu werden",
          "Trauer \u2014 über den schleichenden Verlust der Selbstständigkeit des Angehörigen",
          "Einsamkeit \u2014 soziale Kontakte gehen zurück, weil die Pflege den Alltag bestimmt",
          "Überforderung \u2014 zu viele Aufgaben, zu wenig Zeit und zu wenig Pausen",
          "Angst \u2014 vor der eigenen Zukunft und vor dem, was noch kommen könnte"
        ],
        paragraphs: [
          "Pflegebegleitung kann hier einen wichtigen Beitrag leisten: als verlässlicher Gesprächspartner, als Orientierungshilfe und als Brücke zu professionellen Unterstützungsangeboten."
        ]
      },
      {
        heading: "Organisatorische Herausforderungen",
        paragraphs: [
          "Neben der emotionalen Seite stehen Angehörige vor zahlreichen organisatorischen Aufgaben, die oft als überwältigend empfunden werden:"
        ],
        bullets: [
          "Arzttermine koordinieren und begleiten",
          "Medikamente verwalten und Therapiepläne einhalten",
          "Pflegeleistungen beantragen und abrechnen",
          "Hilfsmittel beschaffen und Wohnraumanpassungen organisieren",
          "Verschiedene Dienstleister und Helfer koordinieren",
          "Den eigenen Beruf und die Pflege unter einen Hut bringen"
        ]
      },
      {
        heading: "Entlastungsmöglichkeiten für Angehörige",
        paragraphs: [
          "Es gibt bereits heute verschiedene Leistungen, die pflegende Angehörige entlasten können. Viele werden jedoch nicht oder nicht vollständig genutzt \u2014 oft aus Unwissenheit:"
        ],
        bullets: [
          "Verhinderungspflege: Bis zu 3.539 Euro jährlich für eine Vertretung bei Ausfall der Pflegeperson (ab Pflegegrad 2)",
          "Kurzzeitpflege: Vorübergehende vollstationäre Pflege, z. B. nach einem Krankenhausaufenthalt",
          "Entlastungsbetrag: 131 Euro monatlich für anerkannte Entlastungsangebote (alle Pflegegrade)",
          "Pflegekurse: Kostenlose Schulungen für pflegende Angehörige durch die Pflegekasse",
          "Tages- und Nachtpflege: Teilstationäre Betreuung zur Entlastung der häuslichen Pflege",
          "Pflegeberatung: Kostenlose Beratung nach \u00a7 7a SGB XI zu allen Fragen rund um die Pflege"
        ],
        paragraphs: [
          "Pflegebegleitung kann helfen, diese Leistungen zu kennen, zu beantragen und sinnvoll zu kombinieren."
        ]
      },
      {
        heading: "Beispiele aus dem Alltag",
        paragraphs: [
          "Wie Pflegebegleitung im Alltag konkret aussehen kann, zeigen diese Beispiele:"
        ],
        example: { title: "Berufstätige Tochter", text: "Frau Keller arbeitet in Teilzeit und pflegt abends ihren Vater. Sie weiß nicht, dass sie Verhinderungspflege nutzen kann, um regelmäßig freie Wochenenden zu haben. Eine Pflegebegleitung klärt sie über ihre Ansprüche auf und hilft bei der Organisation." }
      },
      {
        heading: "",
        paragraphs: [],
        example: { title: "Ehepaar ohne Kinder in der Nähe", text: "Herr und Frau Braun sind aufeinander angewiesen. Als Frau Braun stürzt und operiert werden muss, weiß Herr Braun nicht, wie er die Pflege allein bewältigen soll. Pflegebegleitung vermittelt ihm schnell Hilfe und organisiert Kurzzeitpflege für seine Frau." }
      },
      {
        heading: "Nutzen einer professionellen Begleitung",
        paragraphs: [
          "Professionelle Pflegebegleitung bietet gegenüber dem Alleingang wesentliche Vorteile: Sie haben einen festen Ansprechpartner, der Ihre Situation kennt. Sie erhalten individuelle Empfehlungen statt allgemeiner Informationen. Und Sie werden langfristig begleitet \u2014 nicht nur punktuell beraten.",
          "Unsere digitale Pflegeberatung verbindet fachliche Kompetenz mit persönlicher Begleitung. Wir unterstützen Sie nicht nur mit Informationen, sondern begleiten Sie dabei, diese auch umzusetzen. Kostenfrei mit Pflegegrad, bequem per Video, Telefon oder vor Ort."
        ]
      }
    ],
    faq: [
      { q: "Gibt es Pflegebegleitung speziell für Angehörige?", a: "Ja, Pflegebegleitung richtet sich ganz wesentlich an pflegende Angehörige. Sie soll dazu beitragen, die Belastung im Pflegealltag zu reduzieren und Unterstützung zu vermitteln." },
      { q: "Welche Entlastungsleistungen stehen mir als Angehöriger zu?", a: "Je nach Pflegegrad stehen Ihnen verschiedene Leistungen zu: Verhinderungspflege, Kurzzeitpflege, Entlastungsbetrag, Pflegekurse und Beratung. Viele Familien nutzen nicht alle Möglichkeiten \u2014 lassen Sie sich beraten." },
      { q: "Wie finde ich Unterstützung als pflegender Angehöriger?", a: "Ein guter erster Schritt ist eine professionelle Pflegeberatung. Wir helfen Ihnen, alle verfügbaren Leistungen zu kennen und den Pflegealltag besser zu organisieren." },
      { q: "Kann ich als Angehöriger eine Auszeit von der Pflege nehmen?", a: "Ja, die Verhinderungspflege ermöglicht genau das. Bis zu sechs Wochen pro Jahr kann eine Vertretung die Pflege übernehmen, während Sie sich erholen." }
    ]
  },
  {
    slug: "pflegebegleitung-pflegeberatung",
    title: "Pflegebegleitung und Pflegeberatung: Wo liegt der Unterschied?",
    metaTitle: "Pflegebegleitung vs. Pflegeberatung: Der Unterschied erklärt",
    metaDescription: "Was unterscheidet Pflegebegleitung von Pflegeberatung? Verständliche Erklärung mit Praxisbeispielen und Tipps für Angehörige.",
    category: "Pflegeberatung",
    readTime: "7 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Pflegebegleitung und Pflegeberatung \u2014 zwei Begriffe, die ähnlich klingen, aber unterschiedliche Schwerpunkte haben. Dieser Artikel erklärt verständlich, worin sich beide unterscheiden, wo sie sich ergänzen und wann welche Form der Unterstützung sinnvoll sein kann.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-angehoerige", "pflegebegleitung-pflegegrad", "pflegebegleitung-betreuung", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Was ist Pflegeberatung?",
        paragraphs: [
          "Die Pflegeberatung ist ein gesetzlich verankerter Anspruch im deutschen Pflegesystem. Nach \u00a7 7a SGB XI hat jeder, der Pflegeleistungen beantragt oder erhält, das Recht auf eine individuelle Pflegeberatung. Diese wird von den Pflegekassen oder unabhängigen Beratungsstellen angeboten.",
          "Die Pflegeberatung umfasst typischerweise:"
        ],
        bullets: [
          "Erfassung und Analyse der individuellen Pflegesituation",
          "Information über alle verfügbaren Leistungen und Ansprüche",
          "Erstellung eines individuellen Versorgungsplans",
          "Hilfe bei der Beantragung von Leistungen",
          "Beratung zu Pflegehilfsmitteln und Wohnraumanpassung"
        ],
        paragraphs: [
          "Ein besonderer Baustein ist der Beratungseinsatz nach \u00a7 37 Abs. 3 SGB XI, der für Empfänger von Pflegegeld verpflichtend ist. Dieser regelmäßige Beratungsbesuch stellt sicher, dass die häusliche Pflege fachlich begleitet wird."
        ]
      },
      {
        heading: "Was ist Pflegebegleitung?",
        paragraphs: [
          "Pflegebegleitung geht über die punktuelle Beratung hinaus. Sie beschreibt eine kontinuierliche, begleitende Unterstützung im Pflegealltag. Während die Pflegeberatung sich auf Information und Planung konzentriert, liegt der Fokus der Pflegebegleitung auf der Umsetzung im Alltag.",
          "Pflegebegleitung umfasst:"
        ],
        bullets: [
          "Langfristige Begleitung der Pflegesituation",
          "Emotionale Unterstützung für Angehörige",
          "Praktische Hilfe bei der Umsetzung von Empfehlungen",
          "Vermittlung zwischen Betroffenen und Leistungsanbietern",
          "Krisenintervention bei akuten Überlastungssituationen"
        ]
      },
      {
        heading: "Unterschiede auf einen Blick",
        paragraphs: [
          "Die wesentlichen Unterschiede lassen sich wie folgt zusammenfassen:"
        ],
        bullets: [
          "Pflegeberatung: Gesetzlich verankert, fachlich fokussiert, punktuell, durch Pflegekasse finanziert",
          "Pflegebegleitung: Ergänzendes Angebot, alltagsnah, kontinuierlich, verschiedene Finanzierungsmodelle",
          "Pflegeberatung: Konzentriert sich auf Leistungen, Ansprüche und Versorgungsplanung",
          "Pflegebegleitung: Fokus auf Umsetzung, emotionale Unterstützung und Alltagsbewältigung"
        ]
      },
      {
        heading: "Gemeinsamkeiten",
        paragraphs: [
          "Trotz der Unterschiede haben Pflegebegleitung und Pflegeberatung wichtige Gemeinsamkeiten:"
        ],
        bullets: [
          "Beide zielen darauf ab, Pflegebedürftige und Angehörige zu unterstützen",
          "Beide helfen, die häusliche Pflege zu stabilisieren",
          "Beide können dazu beitragen, Leistungen besser zu nutzen",
          "Beide setzen auf individuelle, bedarfsgerechte Unterstützung"
        ],
        paragraphs: [
          "In der Praxis verschwimmen die Grenzen häufig. Gute Pflegeberatung beinhaltet oft auch begleitende Elemente, und Pflegebegleitung schließt fachliche Information nicht aus."
        ]
      },
      {
        heading: "Praktische Beispiele",
        paragraphs: [],
        example: { title: "Pflegeberatung in der Praxis", text: "Herr Fischer hat gerade den Pflegegrad 2 für seine Mutter erhalten. In einer Pflegeberatung erfährt er, welche Leistungen seiner Mutter zustehen: Pflegegeld, Entlastungsbetrag, Verhinderungspflege. Der Berater erstellt einen Versorgungsplan mit konkreten Empfehlungen." }
      },
      {
        heading: "",
        paragraphs: [],
        example: { title: "Pflegebegleitung in der Praxis", text: "Drei Monate später fühlt sich Herr Fischer überfordert. Die Empfehlungen aus der Beratung konnte er nur teilweise umsetzen. Eine Pflegebegleitung hilft ihm nun Schritt für Schritt: gemeinsam werden Anbieter gesucht, der Entlastungsbetrag beantragt und ein Wochenplan erstellt." }
      },
      {
        heading: "Wann ist welche Unterstützung sinnvoll?",
        paragraphs: [
          "Als Faustregel gilt: Pflegeberatung ist der richtige erste Schritt, um einen Überblick zu bekommen. Pflegebegleitung wird dann wichtig, wenn es an der Umsetzung im Alltag hapert oder wenn die Pflegesituation sich verändert und regelmäßige Anpassungen nötig sind.",
          "In unserer digitalen Pflegeberatung verbinden wir beide Ansätze: Wir informieren Sie umfassend über Ihre Ansprüche und begleiten Sie dabei, diese auch tatsächlich im Alltag zu nutzen. Die Beratung nach \u00a7 37 Abs. 3 SGB XI ist kostenfrei und wird von Ihrer Pflegekasse übernommen."
        ]
      }
    ],
    faq: [
      { q: "Ist Pflegeberatung kostenlos?", a: "Ja, die Pflegeberatung nach \u00a7 7a SGB XI ist für Versicherte kostenfrei. Auch der verpflichtende Beratungseinsatz nach \u00a7 37 Abs. 3 SGB XI wird vollständig von der Pflegekasse übernommen." },
      { q: "Kann ich beides nutzen \u2014 Pflegeberatung und Pflegebegleitung?", a: "Ja, beide Formen der Unterstützung ergänzen sich sinnvoll. In unserer Pflegeberatung bieten wir bereits begleitende Elemente an." },
      { q: "Muss ich einen Pflegegrad haben, um Pflegeberatung zu erhalten?", a: "Nein, auch wer noch keinen Pflegegrad hat, kann eine Pflegeberatung in Anspruch nehmen \u2014 zum Beispiel bei der Antragstellung." }
    ]
  },
  {
    slug: "pflegebegleitung-demenz",
    title: "Pflegebegleitung bei Demenz: Unterstützung für Familien",
    metaTitle: "Pflegebegleitung bei Demenz: Hilfe für Angehörige",
    metaDescription: "Pflegebegleitung bei Demenz: Wie Familien unterstützt werden können. Orientierungshilfe, Entlastung und praktische Beispiele für den Pflegealltag.",
    category: "Demenz",
    readTime: "8 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Die Pflege eines Menschen mit Demenz stellt Familien vor ganz besondere Herausforderungen. Der schleichende Verlust von Erinnerung, Orientierung und Alltagsfähigkeiten ist für alle Beteiligten belastend. Pflegebegleitung kann Familien helfen, diesen Weg nicht allein zu gehen.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-angehoerige", "pflegebegleitung-pflegegrad", "pflegebegleitung-nrw", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Besondere Herausforderungen bei Demenz",
        paragraphs: [
          "Demenz verändert das Zusammenleben grundlegend. Für Angehörige bedeutet die Pflege eines demenzkranken Menschen:"
        ],
        bullets: [
          "24-Stunden-Aufmerksamkeit: Menschen mit Demenz brauchen oft rund um die Uhr Aufsicht und Betreuung",
          "Veränderte Kommunikation: Gespräche werden schwieriger, Missverständnisse nehmen zu",
          "Verhaltensveränderungen: Unruhe, Aggression oder Weglauftendenz können den Alltag stark belasten",
          "Emotionale Erschöpfung: Der Verlust der vertrauten Person bei gleichzeitiger Pflegeverantwortung ist besonders belastend",
          "Fortschreitender Verlauf: Die Erkrankung verschlechtert sich, was ständige Anpassungen erfordert"
        ],
        paragraphs: [
          "In Deutschland leben etwa 1,8 Millionen Menschen mit einer Demenzerkrankung. Die Mehrheit wird zuhause von Angehörigen gepflegt. Gerade diese Familien brauchen umfassende Unterstützung."
        ]
      },
      {
        heading: "Orientierungshilfe für Angehörige",
        paragraphs: [
          "Viele Angehörige fühlen sich nach der Diagnose Demenz zunächst hilflos und überfordert. Es gibt zwar zahlreiche Hilfsangebote, aber der Zugang ist oft unübersichtlich.",
          "Pflegebegleitung kann hier als Lotse fungieren:"
        ],
        bullets: [
          "Erklärung der Erkrankung und des zu erwartenden Verlaufs",
          "Information über spezialisierte Beratungsangebote für Demenz",
          "Hinweise auf Selbsthilfegruppen und Angehörigengruppen",
          "Vermittlung an gerontopsychiatrische Fachstellen",
          "Unterstützung bei der Pflegegradbeantragung und Höherstufung"
        ]
      },
      {
        heading: "Entlastungsmöglichkeiten bei Demenz",
        paragraphs: [
          "Für die Pflege bei Demenz stehen verschiedene Leistungen zur Verfügung, die gezielt Entlastung schaffen können:"
        ],
        bullets: [
          "Tagespflege: Betreuung tagsüber in einer spezialisierten Einrichtung \u2014 mit Abholung und Rückbringung",
          "Verhinderungspflege: Vertretung der Pflegeperson bei Ausfall oder Erholung",
          "Entlastungsbetrag: 131 Euro monatlich für anerkannte Betreuungsangebote",
          "Stundenweise Betreuung: Qualifizierte Betreuungskräfte, die den Angehörigen freie Zeit verschaffen",
          "Pflegehilfsmittel: Technische Hilfsmittel wie GPS-Tracker oder Sicherungssysteme"
        ],
        paragraphs: [
          "Pflegebegleitung hilft dabei, diese Leistungen zu kennen, zu beantragen und sinnvoll in den Pflegealltag zu integrieren."
        ]
      },
      {
        heading: "Begleitung im Alltag mit Demenz",
        paragraphs: [
          "Der Alltag mit einem demenzkranken Angehörigen erfordert viel Geduld, Kreativität und Wissen. Pflegebegleitung kann praktische Hilfestellung geben:"
        ],
        bullets: [
          "Tagesstruktur anpassen an die Bedürfnisse des Erkrankten",
          "Kommunikationsstrategien vermitteln für den Umgang mit Vergesslichkeit und Verwirrung",
          "Sicherheitsmaßnahmen besprechen für die Wohnung",
          "Beschäftigungsangebote entwickeln, die Freude bereiten",
          "Ernährung und Medikamentenmanagement unterstützen"
        ]
      },
      {
        heading: "Praktische Beispiele",
        paragraphs: [],
        example: { title: "Diagnose Demenz: Wie weiter?", text: "Familie Richter hat gerade die Diagnose Alzheimer-Demenz für die Mutter erhalten. Sie wissen nicht, was auf sie zukommt. Eine Pflegebegleitung erklärt den voraussichtlichen Verlauf, hilft bei der Pflegegradbeantragung und vermittelt Kontakte zu einer Angehörigengruppe." }
      },
      {
        heading: "",
        paragraphs: [],
        example: { title: "Fortgeschrittene Demenz: Am Limit", text: "Herr Koch pflegt seine Frau mit fortgeschrittener Demenz seit vier Jahren. Er ist erschöpft und denkt über ein Pflegeheim nach. Pflegebegleitung zeigt ihm Alternativen: Tagespflege drei Mal pro Woche und regelmäßige Verhinderungspflege am Wochenende verschaffen ihm die nötige Erholung." }
      },
      {
        heading: "Unsere Unterstützung für Familien mit Demenz",
        paragraphs: [
          "In unserer digitalen Pflegeberatung begegnen uns regelmäßig Familien, die einen Angehörigen mit Demenz pflegen. Wir wissen um die besonderen Herausforderungen und bieten individuelle Beratung an.",
          "Ob Fragen zum Pflegegrad, zu Entlastungsmöglichkeiten oder zur Organisation des Pflegealltags \u2014 wir sind für Sie da. Kostenfrei per Video, Telefon oder vor Ort."
        ]
      }
    ],
    faq: [
      { q: "Kann Pflegebegleitung bei Demenz helfen?", a: "Ja, gerade bei Demenz ist Pflegebegleitung besonders wertvoll. Angehörige stehen vor einzigartigen Herausforderungen und profitieren von Orientierungshilfe, emotionalem Beistand und praktischer Unterstützung." },
      { q: "Welchen Pflegegrad bekommt man bei Demenz?", a: "Das hängt vom Schweregrad der Erkrankung ab. Bereits bei leichter Demenz kann Pflegegrad 2 oder 3 anerkannt werden. Bei fortgeschrittener Demenz sind Pflegegrad 4 oder 5 möglich." },
      { q: "Gibt es spezielle Betreuungsangebote bei Demenz?", a: "Ja, es gibt spezialisierte Tagespflegen, Betreuungsgruppen und Einzelbetreuung. Der Entlastungsbetrag kann für solche Angebote eingesetzt werden." },
      { q: "Wie finde ich eine Demenz-Selbsthilfegruppe?", a: "Wir vermitteln Ihnen gerne Kontakte zu Angehörigengruppen in Ihrer Region. Sprechen Sie uns in der Pflegeberatung an." }
    ]
  },
  {
    slug: "pflegebegleitung-pflegegrad",
    title: "Pflegebegleitung und Pflegegrad: Welche Rolle spielt der Pflegegrad?",
    metaTitle: "Pflegebegleitung und Pflegegrad: Zusammenhang erklärt",
    metaDescription: "Welche Rolle spielt der Pflegegrad bei der Pflegebegleitung? Leistungen pro Pflegegrad, Beantragung und warum Beratung wichtig ist.",
    category: "Pflegegrad",
    readTime: "7 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Der Pflegegrad ist im deutschen Pflegesystem die zentrale Grundlage für Leistungsansprüche. Doch welche Rolle spielt er bei der Pflegebegleitung? Und was bedeuten die verschiedenen Pflegegrade für den Unterstützungsbedarf im Alltag? Dieser Artikel gibt Antworten.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-angehoerige", "pflegebegleitung-pflegeberatung", "pflegebegleitung-2027", "sozialraumbudget-pflegegrad", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Die fünf Pflegegrade im Überblick",
        paragraphs: [
          "Seit 2017 wird die Pflegebedürftigkeit in Deutschland in fünf Pflegegrade eingeteilt:"
        ],
        bullets: [
          "Pflegegrad 1: Geringe Beeinträchtigung der Selbstständigkeit \u2014 Entlastungsbetrag (131 Euro/Monat), Pflegeberatung, Pflegehilfsmittel",
          "Pflegegrad 2: Erhebliche Beeinträchtigung \u2014 Pflegegeld (347 Euro), Sachleistungen (796 Euro), alle Entlastungsleistungen",
          "Pflegegrad 3: Schwere Beeinträchtigung \u2014 Pflegegeld (599 Euro), Sachleistungen (1.497 Euro), erweiterte Leistungen",
          "Pflegegrad 4: Schwerste Beeinträchtigung \u2014 Pflegegeld (800 Euro), Sachleistungen (1.859 Euro), umfassende Versorgung",
          "Pflegegrad 5: Schwerste Beeinträchtigung mit besonderen Anforderungen \u2014 Pflegegeld (990 Euro), Sachleistungen (2.299 Euro)"
        ],
        paragraphs: [
          "Der Pflegegrad wird durch den Medizinischen Dienst (MD) festgestellt. Grundlage ist die Begutachtung der Selbstständigkeit in sechs Lebensbereichen."
        ]
      },
      {
        heading: "Pflegegrad und Unterstützungsbedarf",
        paragraphs: [
          "Je höher der Pflegegrad, desto umfangreicher sind die formalen Leistungen. Gleichzeitig steigt in der Regel auch der Bedarf an Unterstützung im Alltag. Pflegebegleitung kann auf jeder Stufe wertvoll sein \u2014 allerdings aus unterschiedlichen Gründen:"
        ],
        bullets: [
          "Bei Pflegegrad 1: Die formalen Leistungen sind begrenzt. Pflegebegleitung hilft, den Entlastungsbetrag optimal zu nutzen und frühzeitig Strukturen aufzubauen",
          "Bei Pflegegrad 2\u20133: Die Vielfalt der Leistungen wächst. Pflegebegleitung hilft, den Überblick zu behalten und Leistungen zu kombinieren",
          "Bei Pflegegrad 4\u20135: Der Unterstützungsbedarf ist hoch. Pflegebegleitung entlastet Angehörige emotional und hilft bei der Koordination verschiedener Dienstleister"
        ]
      },
      {
        heading: "Häufige Fragen von Angehörigen zum Pflegegrad",
        paragraphs: [
          "In unserer Beratungspraxis begegnen uns regelmäßig ähnliche Fragen rund um den Pflegegrad:"
        ],
        bullets: [
          "Wann sollte ich einen Pflegegrad beantragen? \u2014 Sobald eine dauerhafte Beeinträchtigung der Selbstständigkeit vorliegt",
          "Wie bereite ich mich auf die Begutachtung vor? \u2014 Ein Pflegetagebuch hilft, den tatsächlichen Hilfebedarf zu dokumentieren",
          "Was tun, wenn der Pflegegrad zu niedrig ausfällt? \u2014 Sie können Widerspruch einlegen. Wir beraten Sie dazu",
          "Kann der Pflegegrad erhöht werden? \u2014 Ja, bei Verschlechterung des Zustands können Sie eine Höherstufung beantragen",
          "Verliert man den Pflegegrad wieder? \u2014 Bei Verbesserung des Zustands kann eine Rückstufung erfolgen, das ist aber eher selten"
        ]
      },
      {
        heading: "Beispiele aus dem Alltag",
        paragraphs: [],
        example: { title: "Pflegegrad 1: Der Anfang", text: "Frau Lehmann hat Pflegegrad 1 erhalten. Sie lebt allein und kommt im Alltag noch weitgehend zurecht, braucht aber Unterstützung beim Einkaufen und bei Behördengängen. Eine Pflegebegleitung hilft ihr, den Entlastungsbetrag für eine regelmäßige Alltagshilfe einzusetzen." }
      },
      {
        heading: "",
        paragraphs: [],
        example: { title: "Pflegegrad 3: Komplexe Situation", text: "Herr Schäfer hat Pflegegrad 3 und wird von seiner Tochter gepflegt. Die Familie nutzt bisher nur das Pflegegeld, obwohl weitere Leistungen zustehen. Pflegebegleitung deckt auf, dass der Entlastungsbetrag seit einem Jahr ungenutzt verfällt und Verhinderungspflege nie beantragt wurde." }
      },
      {
        heading: "Warum Beratung beim Pflegegrad so wichtig ist",
        paragraphs: [
          "Viele Betroffene unterschätzen den Zusammenhang zwischen Pflegegrad und verfügbaren Leistungen. In unserer Praxis erleben wir häufig, dass Familien Tausende Euro an Leistungen nicht in Anspruch nehmen \u2014 einfach, weil sie nicht wissen, was ihnen zusteht.",
          "Eine professionelle Pflegeberatung hilft, den Pflegegrad richtig einzuordnen, alle Leistungen zu kennen und optimal zu nutzen. Bei Bedarf unterstützen wir auch bei der Antragstellung und bei Widersprüchen."
        ]
      }
    ],
    faq: [
      { q: "Brauche ich einen Pflegegrad für Pflegebegleitung?", a: "Nicht unbedingt. Pflegebegleitung kann grundsätzlich jeder in Anspruch nehmen. Allerdings sind viele Leistungen, die im Rahmen der Begleitung vermittelt werden, an einen Pflegegrad gekoppelt." },
      { q: "Welchen Pflegegrad brauche ich für welche Leistung?", a: "Ab Pflegegrad 1 gibt es den Entlastungsbetrag und Pflegeberatung. Ab Pflegegrad 2 kommen Pflegegeld, Verhinderungspflege und weitere Leistungen hinzu. Wir beraten Sie individuell." },
      { q: "Kann eine Pflegebegleitung beim Pflegegradantrag helfen?", a: "Ja, Pflegebegleitung und Pflegeberatung können bei der Vorbereitung auf die Begutachtung und bei der Antragstellung unterstützen." },
      { q: "Was kostet die Begutachtung durch den MD?", a: "Die Begutachtung durch den Medizinischen Dienst ist für Sie kostenlos. Sie wird von der Pflegekasse beauftragt und bezahlt." }
    ]
  },
  {
    slug: "pflegebegleitung-2027",
    title: "Pflegebegleitung 2027: Was ist aktuell geplant?",
    metaTitle: "Pflegebegleitung 2027: Aktueller Diskussionsstand",
    metaDescription: "Was ist zum Thema Pflegebegleitung 2027 bekannt? Aktueller Diskussionsstand, mögliche Entwicklungen und was Angehörige jetzt tun können.",
    category: "Pflegereform",
    readTime: "6 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Im Zusammenhang mit der geplanten Pflegereform wird auch das Thema Pflegebegleitung diskutiert. Könnte es 2027 neue Angebote oder gesetzliche Regelungen geben? Dieser Artikel fasst den aktuellen Diskussionsstand zusammen \u2014 sachlich und ohne Spekulationen.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-pflegegrad", "pflegebegleitung-betreuung", "pflegebegleitung-nrw", "sozialraumbudget-2027", "pflegereform-2027", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Warum das Jahr 2027 als Orientierung dient",
        paragraphs: [
          "Das Jahr 2027 wird in der politischen Diskussion häufig als möglicher Zeitrahmen für umfassende Pflegereformen genannt. Im Rahmen dieser Reformen könnten auch begleitende Unterstützungsangebote wie die Pflegebegleitung gestärkt werden.",
          "Es ist wichtig zu betonen: Es gibt keinen verbindlichen Termin. Gesetzgebungsverfahren können sich verzögern oder inhaltlich verändern. Die folgenden Informationen geben den aktuellen Diskussionsstand wieder."
        ],
        highlight: "Stand heute gibt es keine verbindlichen Beschlüsse zur gesetzlichen Verankerung der Pflegebegleitung. Alle Zeitangaben sind Orientierungswerte."
      },
      {
        heading: "Was wird aktuell diskutiert?",
        paragraphs: [
          "In verschiedenen Fachgremien und politischen Arbeitsgruppen werden folgende Aspekte der Pflegebegleitung erörtert:"
        ],
        bullets: [
          "Stärkung ehrenamtlicher Pflegebegleitungsangebote",
          "Bessere Vernetzung von Beratung und Begleitung",
          "Mögliche Integration in bestehende Leistungsstrukturen",
          "Ausbau niedrigschwelliger Unterstützungsangebote",
          "Stärkere Einbindung digitaler Beratungsformate",
          "Systematische Entlastung pflegender Angehöriger"
        ]
      },
      {
        heading: "Mögliche Entwicklungen",
        paragraphs: [
          "Nach aktuellem Diskussionsstand könnten folgende Entwicklungen eintreten:"
        ],
        bullets: [
          "Pflegebegleitung könnte als ergänzende Leistung im Pflegesystem verankert werden",
          "Die Finanzierung könnte über bestehende Instrumente wie den Entlastungsbetrag erfolgen",
          "Digitale Formate könnten den Zugang zu Pflegebegleitung erleichtern",
          "Regionale Modellprojekte könnten ausgeweitet werden",
          "Die Qualifizierung von ehrenamtlichen und professionellen Pflegebegleitern könnte standardisiert werden"
        ],
        highlight: "Die endgültige gesetzliche Ausgestaltung bleibt abzuwarten. Wir informieren Sie, sobald verbindliche Regelungen bekannt werden."
      },
      {
        heading: "Bedeutung für Pflegebedürftige und Angehörige",
        paragraphs: [
          "Eine Stärkung der Pflegebegleitung könnte für Betroffene bedeuten: mehr alltagsnahe Unterstützung, besserer Zugang zu Hilfsangeboten und eine stärkere emotionale Begleitung im Pflegealltag.",
          "Für Angehörige könnte es bedeuten: weniger Bürokratie, mehr Entlastung und einen festen Ansprechpartner, der die Pflegesituation kennt und langfristig begleitet."
        ]
      },
      {
        heading: "Was Sie jetzt schon tun können",
        paragraphs: [
          "Auch wenn die gesetzliche Ausgestaltung noch aussteht, können Sie bereits jetzt aktiv werden:"
        ],
        bullets: [
          "Nutzen Sie Ihre bestehenden Leistungen optimal \u2014 viele Familien lassen Geld verfallen",
          "Lassen Sie Ihren Pflegegrad überprüfen, wenn sich der Zustand verändert hat",
          "Nehmen Sie eine professionelle Pflegeberatung in Anspruch \u2014 wir helfen Ihnen dabei",
          "Informieren Sie sich regelmäßig über Entwicklungen im Pflegebereich",
          "Vernetzen Sie sich mit anderen Betroffenen in Selbsthilfegruppen"
        ]
      }
    ],
    faq: [
      { q: "Kommt die Pflegebegleitung sicher 2027?", a: "Ein verbindlicher Termin steht nicht fest. 2027 wird als möglicher Zeitrahmen für Pflegereformen diskutiert, in deren Rahmen auch Pflegebegleitung gestärkt werden könnte." },
      { q: "Gibt es schon jetzt Pflegebegleitung?", a: "Ja, in einigen Regionen gibt es bereits ehrenamtliche und professionelle Pflegebegleitungsangebote. Die gesetzliche Verankerung als eigenständige Leistung wird diskutiert." },
      { q: "Wie bleibe ich über Änderungen informiert?", a: "Wir aktualisieren unsere Ratgeber-Artikel regelmäßig. Für individuelle Fragen steht Ihnen unsere digitale Pflegeberatung zur Verfügung." }
    ]
  },
  {
    slug: "pflegebegleitung-betreuung",
    title: "Pflegebegleitung oder Betreuung? Die Unterschiede einfach erklärt",
    metaTitle: "Pflegebegleitung vs. Betreuung: Unterschiede erklärt",
    metaDescription: "Was unterscheidet Pflegebegleitung von Betreuung? Verständliche Erklärung mit Praxisbeispielen für Pflegebedürftige und Angehörige.",
    category: "Betreuung",
    readTime: "6 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Pflegebegleitung und Betreuung \u2014 zwei Begriffe, die im Pflegealltag häufig fallen, aber unterschiedliche Formen der Unterstützung beschreiben. Dieser Artikel klärt die Unterschiede verständlich und praxisnah.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-angehoerige", "pflegebegleitung-pflegeberatung", "pflegebegleitung-demenz", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Was bedeutet Betreuung im Pflegesystem?",
        paragraphs: [
          "Im Pflegesystem umfasst Betreuung konkrete Hilfen für den Pflegebedürftigen selbst. Es geht um die direkte Unterstützung und Beaufsichtigung im Alltag. Typische Betreuungsleistungen sind:"
        ],
        bullets: [
          "Beaufsichtigung und Begleitung im Alltag",
          "Gemeinsame Aktivitäten wie Spaziergänge, Spiele oder Vorlesen",
          "Unterstützung bei der Tagesstrukturierung",
          "Begleitung zu Arztterminen und Therapien",
          "Anleitung und Hilfe bei alltäglichen Verrichtungen"
        ],
        paragraphs: [
          "Betreuung kann durch professionelle Betreuungskräfte, ehrenamtliche Helfer oder über Betreuungsgruppen in Tageseinrichtungen erfolgen. Sie wird über verschiedene Pflegeleistungen finanziert, etwa den Entlastungsbetrag oder die Sachleistungen."
        ]
      },
      {
        heading: "Was unterscheidet die Pflegebegleitung?",
        paragraphs: [
          "Während Betreuung sich primär an den Pflegebedürftigen richtet und konkrete Hilfen umfasst, hat Pflegebegleitung einen breiteren Ansatz:"
        ],
        bullets: [
          "Pflegebegleitung richtet sich auch an Angehörige, nicht nur an den Pflegebedürftigen",
          "Pflegebegleitung umfasst organisatorische und emotionale Unterstützung",
          "Pflegebegleitung hilft beim Navigieren im Pflegesystem",
          "Pflegebegleitung zielt auf die Stabilisierung der gesamten Pflegesituation",
          "Pflegebegleitung ist eher beratend und koordinierend als direkt betreuend"
        ]
      },
      {
        heading: "Gemeinsamkeiten",
        paragraphs: [
          "Trotz der Unterschiede gibt es wichtige Gemeinsamkeiten:"
        ],
        bullets: [
          "Beide zielen auf die Verbesserung der Pflegesituation ab",
          "Beide können ambulant, also im häuslichen Umfeld, stattfinden",
          "Beide tragen zur Entlastung von Angehörigen bei",
          "Beide können über Pflegeleistungen finanziert werden",
          "Beide setzen auf individuelle, bedarfsgerechte Hilfen"
        ]
      },
      {
        heading: "Praxisbeispiele: Betreuung und Pflegebegleitung im Vergleich",
        paragraphs: [],
        example: { title: "Betreuung in der Praxis", text: "Frau Meier hat Pflegegrad 3 und Demenz. Jeden Dienstag und Donnerstag kommt eine Betreuungskraft für drei Stunden. Sie liest mit Frau Meier vor, macht Gedächtnisspiele und begleitet sie beim Spaziergang. In dieser Zeit kann die Tochter zum Einkaufen gehen." }
      },
      {
        heading: "",
        paragraphs: [],
        example: { title: "Pflegebegleitung in der Praxis", text: "Die Tochter von Frau Meier fühlt sich überfordert mit der Organisation. Im Rahmen einer Pflegebegleitung wird gemeinsam ein Wochenplan erstellt, die Verhinderungspflege beantragt und ein Kontakt zur Alzheimer-Gesellschaft hergestellt. Die Tochter hat nun einen Ansprechpartner für alle Fragen rund um die Pflege." }
      },
      {
        heading: "Wann brauche ich was?",
        paragraphs: [
          "Als Orientierung: Betreuung ist die richtige Wahl, wenn der Pflegebedürftige direkte Unterstützung und Gesellschaft im Alltag braucht. Pflegebegleitung ist dann sinnvoll, wenn die Pflegesituation insgesamt organisiert, koordiniert oder stabilisiert werden muss.",
          "In vielen Fällen profitieren Familien von beidem: direkter Betreuung für den Pflegebedürftigen und Pflegebegleitung für die Organisation und emotionale Unterstützung. In unserer Pflegeberatung helfen wir Ihnen, die richtige Kombination zu finden."
        ]
      }
    ],
    faq: [
      { q: "Kann ich Betreuung über den Entlastungsbetrag finanzieren?", a: "Ja, der Entlastungsbetrag von 131 Euro monatlich kann für anerkannte Betreuungsangebote eingesetzt werden." },
      { q: "Ist Pflegebegleitung das Gleiche wie Betreuung?", a: "Nein, beides hat unterschiedliche Schwerpunkte. Betreuung richtet sich an den Pflegebedürftigen direkt, Pflegebegleitung an das gesamte Pflegesystem einschließlich der Angehörigen." },
      { q: "Kann ich beides gleichzeitig nutzen?", a: "Ja, Betreuung und Pflegebegleitung ergänzen sich sinnvoll. In vielen Fällen ist eine Kombination die beste Lösung." }
    ]
  },
  {
    slug: "pflegebegleitung-nrw",
    title: "Pflegebegleitung in NRW: Unterstützung für Angehörige und Pflegebedürftige",
    metaTitle: "Pflegebegleitung in NRW: Unterstützung vor Ort",
    metaDescription: "Pflegebegleitung in Nordrhein-Westfalen: Regionale Angebote, digitale Pflegeberatung und Unterstützung für Angehörige und Pflegebedürftige.",
    category: "NRW",
    readTime: "6 Min.",
    isPillar: false,
    ctaTitle: "Fragen zur Pflegebegleitung oder zu Ihren Pflegeleistungen?",
    ctaText: "Unsere digitale Pflegeberatung unterstützt Pflegebedürftige und Angehörige bei Fragen rund um Pflegegrad, Pflegeleistungen, Beratungsbesuche, Entlastungsangebote und aktuelle Entwicklungen im Pflegesystem.",
    intro: "Nordrhein-Westfalen ist das bevölkerungsreichste Bundesland Deutschlands \u2014 mit über 900.000 Pflegebedürftigen und entsprechend vielen pflegenden Angehörigen. Welche Unterstützung bietet Pflegebegleitung speziell in NRW? Ein Überblick.",
    relatedSlugs: ["pflegebegleitung", "pflegebegleitung-angehoerige", "pflegebegleitung-2027", "sozialraumbudget-nrw", "sozialraumbudget-rechner", "verhinderungspflege-antrag", "pflegeleistungen-finder"],
    sections: [
      {
        heading: "Die Pflegelandschaft in NRW",
        paragraphs: [
          "Nordrhein-Westfalen verfügt über eine der am besten ausgebauten Pflegeinfrastrukturen in Deutschland. Dies bietet gute Voraussetzungen für begleitende Unterstützungsangebote:"
        ],
        bullets: [
          "Über 900.000 Pflegebedürftige in NRW",
          "Ein dichtes Netz an Pflegestützpunkten und Beratungsstellen",
          "Zahlreiche anerkannte Angebote zur Unterstützung im Alltag",
          "Aktive Förderpolitik für innovative Pflegekonzepte",
          "Starke kommunale Strukturen für wohnortnahe Versorgung",
          "Vielfältige ehrenamtliche Initiativen und Selbsthilfegruppen"
        ]
      },
      {
        heading: "Regionale Unterstützungsangebote",
        paragraphs: [
          "In NRW gibt es verschiedene Anlaufstellen und Angebote, die Elemente der Pflegebegleitung beinhalten. Dazu gehören allgemein:"
        ],
        bullets: [
          "Pflegestützpunkte: Zentrale Anlaufstellen für alle Fragen rund um die Pflege, in vielen Städten und Kreisen vorhanden",
          "Pflegeberatung der Pflegekassen: Gesetzlicher Anspruch auf individuelle Beratung",
          "Ehrenamtliche Initiativen: In vielen Gemeinden gibt es Besuchsdienste und Begleitangebote",
          "Angebote zur Unterstützung im Alltag: Nach Landesrecht NRW anerkannte Dienstleister für Betreuung und Entlastung",
          "Selbsthilfegruppen: Anlaufstellen für pflegende Angehörige in vielen Städten"
        ],
        paragraphs: [
          "Die konkrete Verfügbarkeit variiert von Region zu Region. Gerade im ländlichen Raum können Angebote begrenzt sein. Hier können digitale Formate eine wichtige Ergänzung darstellen."
        ]
      },
      {
        heading: "Digitale Pflegebegleitung als Ergänzung",
        paragraphs: [
          "Digitale Pflegeberatung und -begleitung gewinnt in NRW zunehmend an Bedeutung. Die Vorteile liegen auf der Hand:"
        ],
        bullets: [
          "Erreichbarkeit unabhängig vom Wohnort \u2014 auch im ländlichen Raum",
          "Keine Anfahrt nötig \u2014 besonders wertvoll für pflegende Angehörige mit wenig Zeit",
          "Flexible Terminvergabe \u2014 auch außerhalb üblicher Bürozeiten",
          "Vertrauliche Beratung von zuhause aus",
          "Einfacher Zugang per Video oder Telefon"
        ],
        paragraphs: [
          "Unser Beratungsangebot ist speziell auf Nordrhein-Westfalen ausgerichtet. Wir kennen die regionalen Angebote, Ansprechpartner und Besonderheiten in den verschiedenen Regionen NRWs."
        ]
      },
      {
        heading: "Keine ungesicherten Versprechen",
        paragraphs: [
          "Es ist uns wichtig zu betonen: Die konkreten Rahmenbedingungen für eine systematische Pflegebegleitung in NRW befinden sich noch in der Entwicklung. Es gibt keine landesspezifischen Gesetze oder Verordnungen, die Pflegebegleitung als eigenständige Leistung regeln.",
          "Was es gibt, sind gute bestehende Strukturen und engagierte Akteure, die den Pflegealltag für Betroffene und Angehörige verbessern möchten. Sobald es konkrete neue Regelungen gibt, informieren wir Sie."
        ],
        highlight: "Wir verfolgen die Entwicklungen aufmerksam und aktualisieren diesen Artikel, sobald konkrete Informationen für NRW vorliegen."
      },
      {
        heading: "Unsere digitale Pflegeberatung in NRW",
        paragraphs: [
          "Ob Sie in Düsseldorf, Köln, Dortmund, Essen oder in einer ländlichen Gemeinde leben \u2014 unsere digitale Pflegeberatung ist in ganz NRW verfügbar. Wir beraten Sie kostenfrei per Video, Telefon oder vor Ort zu allen Fragen rund um Pflege.",
          "Als Beratungseinsatz nach \u00a7 37 Abs. 3 SGB XI ist diese Leistung bei Vorliegen eines Pflegegrads von der Pflegekasse gedeckt. Rufen Sie uns an oder buchen Sie direkt einen Termin."
        ]
      }
    ],
    faq: [
      { q: "Gibt es Pflegebegleitung in NRW?", a: "In NRW gibt es verschiedene Angebote, die Elemente der Pflegebegleitung beinhalten: Pflegestützpunkte, ehrenamtliche Initiativen und professionelle Beratungsdienste. Eine gesetzliche Verankerung als eigenständige Leistung steht noch aus." },
      { q: "Wo finde ich Unterstützung in NRW?", a: "Pflegestützpunkte, Pflegekassen und Beratungsstellen sind zentrale Anlaufstellen. Unsere digitale Pflegeberatung ist in ganz NRW verfügbar und kann bequem von zuhause genutzt werden." },
      { q: "Ist digitale Pflegeberatung genauso gut wie vor Ort?", a: "Digitale Beratung bietet viele Vorteile: Flexibilität, keine Anfahrt und Erreichbarkeit auch im ländlichen Raum. Für die Erstberatung empfehlen wir einen Präsenztermin, Folgeberatungen sind bequem per Video oder Telefon möglich." },
      { q: "Kostet die Pflegeberatung in NRW etwas?", a: "Nein, die Pflegeberatung nach \u00a7 37 Abs. 3 SGB XI ist kostenfrei und wird von der Pflegekasse übernommen." }
    ]
  }
];

export default clusterPflegebegleitung;
